<span placement="right" pTooltip="{{content}}" tooltipPosition="right" showDelay="250">
  {{content}}
</span>
